<form class="f-col blank-form" [formGroup]="changeRuleForm" (ngSubmit)="savechangeRulesDetails()" >
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managepolicy.changerules']}}</h2>
        <!-- <a role="button" class="link"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">edit</mat-icon> Edit</a> -->
    </div>

    <div class="section-content">
        <div class="inner-contentsection">
            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <mat-slide-toggle formControlName="isFlightchangeAllowed"> {{content?.['b2b.managepolicy.allowflight']}}</mat-slide-toggle>
                        <mat-error
                            *ngIf="changeRuleForm.get('isFlightchangeAllowed')?.hasError('required') && changeRuleForm.get('isFlightchangeAllowed')?.touched">
                            {{content?.['b2b.managepolicy.allowflightchange'] || 'Allow Flight change is required.'}}</mat-error>
                    </div>
                </div>
            </div>
            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managepolicy.faretype']}}</label>
                        <div class="f-row mat-check-group" [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'">
                            <mat-checkbox class="checkbox-wrapper"
                                formControlName="isRefundable">{{content?.['b2b.managepolicy.refundable']}}</mat-checkbox>
                            <mat-checkbox class="checkbox-wrapper"
                                formControlName="isNonRefundable">{{content?.['b2b.managepolicy.nonrefund']}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col">

                    <ng-select autoBlurSelect [items]="reissueWindowDaysList" bindLabel="name" bindValue="id"
                        placeholder="Reissue Window (Days Before Trip Start)" formControlName="reissueWindowDays">
                    </ng-select>
                    <mat-error class="px-4"
                        *ngIf="changeRuleForm.get('reissueWindowDays')?.hasError('required') && changeRuleForm.get('reissueWindowDays')?.touched">
                        {{content?.['b2b.managepolicy.selectreissuewindow'] || 'Select Reissue window days before trip start'}}</mat-error>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managepolicy.limitticket']}}</mat-label>
                        <input matInput formControlName="reissueTicketLimit" maxlength="3" inputmode="numeric"
                            (keypress)="_CommonService.allowNumberOnly($event)" />
                        <mat-error
                            *ngIf="changeRuleForm.get('reissueTicketLimit')?.hasError('required') && changeRuleForm.get('reissueTicketLimit')?.touched">
                            {{content?.['b2b.managepolicy.ticketlimit'] || 'Number of ticket limit re-issue is required.'}}</mat-error>
                    </mat-form-field>
                </div>


            </div>
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managepolicy.maxadc']}}</mat-label>
                        <input matInput formControlName="maxADCAllowed" maxlength="3" inputmode="numeric"
                            (keypress)="_CommonService.allowNumberOnly($event)" />
                        <mat-error
                            *ngIf="changeRuleForm.get('maxADCAllowed')?.hasError('required') && changeRuleForm.get('maxADCAllowed')?.touched">
                            {{content?.['b2b.managepolicy.maxadcallowed'] || 'Maximum ADC allowed is required.'}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small" type="button" (click)="navigateToList()" [disabled]="commonObj.isSubmitting">{{content?.['b2b.managepolicy.cancel']}}</button>
            <button mat-button class="button--primary-small" type="submit"
             [class.disabled]="commonObj.isSubmitting">
             <!-- [class.disabled]="!changeRuleForm.get('isFlightchangeAllowed')?.value || commonObj.isSubmitting"> -->
             {{content?.['b2b.managepolicy.save']}}
                <ng-container *ngIf="commonObj.isSubmitting">
                    <mat-spinner class="button"></mat-spinner>
                </ng-container>
            </button>
        </div>
    </div>
</form>